import type {
    HolisticSummaryCategory,
    SpendAccountCategory,
} from '@fruitful/types';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import { CreateManualAccount } from '../../../../holistic/components/manual-accounts/CreateManualAccount';

export default function NewManualAccount() {
    const { category, type } = useLocalSearchParams<{
        category: HolisticSummaryCategory;
        type: SpendAccountCategory;
    }>();
    return <CreateManualAccount category={category} type={type} />;
}
